export default {
  wrapperColor: Styles.color.grey.three,
};
